const DAYS_IN_YEAR = 360;
const DAYS_IN_MONTH = 30;

export default function getDateBreakdown(days?: number | null) {
  let remainingDays = Math.max(0, days ?? 0);
  const normalizedYearDays = Math.max(1, DAYS_IN_YEAR);

  const years = Math.floor(remainingDays / normalizedYearDays);
  remainingDays %= normalizedYearDays;

  const months = Math.floor(remainingDays / DAYS_IN_MONTH);
  remainingDays %= DAYS_IN_MONTH;

  const DAYS_IN_WEEK = 7;
  const weeks = Math.floor(remainingDays / DAYS_IN_WEEK);
  remainingDays %= DAYS_IN_WEEK;

  return {
    years,
    months,
    weeks,
    days: remainingDays,
  };
}
